/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Remove_Account_TitleInputs */

const en_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Premium account?`)
};

const id_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus akun Premium?`)
};

const ms_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padamkan akaun Premium?`)
};

const ca_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vols eliminar el compte Premium?`)
};

const cs_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat účet Premium?`)
};

const da_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slet Premium-konto?`)
};

const de_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium-Konto löschen?`)
};

const et_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kas kustutada Premium konto?`)
};

const es_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Quieres eliminar la cuenta Premium?`)
};

const fr_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le compte Premium ?`)
};

const hr_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Želite izbrisati račun Premium?`)
};

const it_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellare account Premium?`)
};

const lv_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dzēst Premium kontu?`)
};

const lt_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ištrinti „Premium“ paskyrą?`)
};

const hu_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Törli a Premium fiókot?`)
};

const nl_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium-account verwijderen?`)
};

const nb_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vil du slette Premium-kontoen?`)
};

const pl_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usunąć konto Premium?`)
};

const pt_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir a conta Premium?`)
};

const ro_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ștergi contul Premium?`)
};

const sk_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vymazať účet Premium?`)
};

const sl_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Želite izbrisati račun Premium?`)
};

const fi_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poista Premium-tili?`)
};

const sv_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Radera Premium-konto?`)
};

const vi_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa tài khoản Premium?`)
};

const tr_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium hesap silinsin mi?`)
};

const el_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Διαγραφή Premium λογαριασμού;`)
};

const bg_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изтриване на Premium акаунт?`)
};

const ru_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить Премиум аккаунт?`)
};

const sr_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Желите ли да избришете Premium налог?`)
};

const uk_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видалити преміум-акаунт?`)
};

const ka_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`წავშალოთ პრემიუმ ანგარიში?`)
};

const hi_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीमियम अकाउंट डिलीट करना है?`)
};

const th_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลบบัญชีพรีเมียมหรือไม่`)
};

const ko_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프리미엄 계정을 삭제하시겠습니까?`)
};

const zh_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`要删除 Premium 账户？`)
};

const zh_tw_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`要刪除高級版帳戶？`)
};

const ja_delete_remove_account_title = /** @type {(inputs: Delete_Remove_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレミアムアカウントを削除しますか？`)
};

/**
* | output |
* | --- |
* | "Delete Premium account?" |
*
* @param {Delete_Remove_Account_TitleInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const delete_remove_account_title = /** @type {((inputs?: Delete_Remove_Account_TitleInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Remove_Account_TitleInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_delete_remove_account_title(inputs)
	if (locale === "ms") return ms_delete_remove_account_title(inputs)
	if (locale === "ca") return ca_delete_remove_account_title(inputs)
	if (locale === "cs") return cs_delete_remove_account_title(inputs)
	if (locale === "da") return da_delete_remove_account_title(inputs)
	if (locale === "de") return de_delete_remove_account_title(inputs)
	if (locale === "et") return et_delete_remove_account_title(inputs)
	if (locale === "es") return es_delete_remove_account_title(inputs)
	if (locale === "fr") return fr_delete_remove_account_title(inputs)
	if (locale === "hr") return hr_delete_remove_account_title(inputs)
	if (locale === "it") return it_delete_remove_account_title(inputs)
	if (locale === "lv") return lv_delete_remove_account_title(inputs)
	if (locale === "lt") return lt_delete_remove_account_title(inputs)
	if (locale === "hu") return hu_delete_remove_account_title(inputs)
	if (locale === "nl") return nl_delete_remove_account_title(inputs)
	if (locale === "nb") return nb_delete_remove_account_title(inputs)
	if (locale === "pl") return pl_delete_remove_account_title(inputs)
	if (locale === "pt") return pt_delete_remove_account_title(inputs)
	if (locale === "ro") return ro_delete_remove_account_title(inputs)
	if (locale === "sk") return sk_delete_remove_account_title(inputs)
	if (locale === "sl") return sl_delete_remove_account_title(inputs)
	if (locale === "fi") return fi_delete_remove_account_title(inputs)
	if (locale === "sv") return sv_delete_remove_account_title(inputs)
	if (locale === "vi") return vi_delete_remove_account_title(inputs)
	if (locale === "tr") return tr_delete_remove_account_title(inputs)
	if (locale === "el") return el_delete_remove_account_title(inputs)
	if (locale === "bg") return bg_delete_remove_account_title(inputs)
	if (locale === "ru") return ru_delete_remove_account_title(inputs)
	if (locale === "sr") return sr_delete_remove_account_title(inputs)
	if (locale === "uk") return uk_delete_remove_account_title(inputs)
	if (locale === "ka") return ka_delete_remove_account_title(inputs)
	if (locale === "hi") return hi_delete_remove_account_title(inputs)
	if (locale === "th") return th_delete_remove_account_title(inputs)
	if (locale === "ko") return ko_delete_remove_account_title(inputs)
	if (locale === "zh") return zh_delete_remove_account_title(inputs)
	if (locale === "zh-tw") return zh_tw_delete_remove_account_title(inputs)
	if (locale === "ja") return ja_delete_remove_account_title(inputs)
	return en_delete_remove_account_title(inputs)
});